import Vue from 'vue'
import ImgPop from './ImgPop.vue'

const Pop = Vue.extend(ImgPop)
const element = document.createElement('div')
document.querySelector('body').appendChild(element)
const ImgPopInstance = new Pop({el: element})
if (process.env.NODE_ENV === 'development') window.ImgPopInstance = ImgPopInstance
export default ImgPopInstance



// WEBPACK FOOTER //
// ./src/components/common/img-pop/ImgPopInstance.js